import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const AdminLogin: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!username || !password) { setError('Please enter credentials.'); return; }
    setLoading(true); setError('');
    const ok = await login(username, password);
    setLoading(false);
    if (ok) navigate('/admin');
    else setError('Invalid credentials. Contact System Admin');
  };

  return (
    <div className="login-page">
      <div style={{ position:'absolute', inset:0, backgroundImage:'repeating-linear-gradient(-45deg,transparent,transparent 60px,rgba(232,93,4,0.02) 60px,rgba(232,93,4,0.02) 61px)', pointerEvents:'none' }} />
      <div className="login-card">
        <div style={{ textAlign:'center', marginBottom:'32px' }}>
          <div style={{ width:64, height:64, background:'var(--brand-orange)', borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', boxShadow:'0 8px 24px rgba(232,93,4,0.3)' }}>
            <Shield size={28} color="white" />
          </div>
          <h2 style={{ fontFamily:'var(--font-display)', fontSize:'2rem', color:'var(--text-primary)', marginBottom:6 }}>Admin Portal</h2>
          <p style={{ color:'var(--text-muted)', fontSize:'0.88rem' }}>NIDAVE Industrial Ventures — CMS</p>
        </div>

        {error && <div style={{ padding:'11px 14px', background:'rgba(220,53,69,0.08)', border:'1px solid rgba(220,53,69,0.2)', borderRadius:6, color:'#dc3545', fontSize:'0.86rem', marginBottom:18, fontFamily:'var(--font-condensed)' }}>{error}</div>}

        <div className="contact-form">
          <div className="form-group">
            <label className="form-label">Username</label>
            <input className="form-input" value={username} onChange={e=>setUsername(e.target.value)} placeholder="Enter username" onKeyDown={e=>e.key==='Enter'&&handleLogin()} />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <div style={{ position:'relative' }}>
              <input className="form-input" type={showPass?'text':'password'} value={password} onChange={e=>setPassword(e.target.value)} placeholder="Enter password" onKeyDown={e=>e.key==='Enter'&&handleLogin()} style={{ paddingRight:46 }} />
              <button onClick={()=>setShowPass(s=>!s)} style={{ position:'absolute', right:14, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', color:'var(--text-muted)', cursor:'pointer' }}>
                {showPass ? <EyeOff size={16}/> : <Eye size={16}/>}
              </button>
            </div>
          </div>
          <button className="btn-primary" onClick={handleLogin} disabled={loading} style={{ width:'100%', justifyContent:'center', marginTop:6 }}>
            {loading ? 'Signing In...' : 'Sign In to Admin'}
          </button>
        </div>

        <div style={{ textAlign:'center', marginTop:20 }}>
          <a href="/" style={{ color:'var(--text-muted)', fontSize:'0.84rem', textDecoration:'none' }}>← Back to Website</a>
        </div>
      </div>
    </div>
  );
};
export default AdminLogin;
